// extracted by css-extract-rspack-plugin
export default {"banner":"bulk-add-notifications-module__banner__NiDLT1Y"};